import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DecimalPipe, PercentPipe, DatePipe } from '@angular/common';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { LoginService } from '../auth/login/login.service';
import { PortalService } from '../../auth/portal.service';
import { HeaderService } from '../header/header.service';
import { CalculatorService } from '../calculator/calculator.service';
import { LoginComponent } from '../auth/login/login.component';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
    imports: [
      FormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      LoginComponent, 
      DecimalPipe, 
      PercentPipe, 
      DatePipe]
})
export class OverviewComponent implements OnInit {
	deliveryData: {};
	memberSelect;
  d: Date = new Date();

  constructor(
  	public lS: LoginService,
    public cS: CalculatorService,
    private pS: PortalService,
    private hS: HeaderService
  	) { }

  ngOnInit() {
  	if(this.lS.isAuthenticated()) {
      this.setSeasons();
      this.memberSelect = this.lS.selectedmember;
      this.cacheForMember();
    }
    window.scrollTo(0,0);
  }

   cacheForMember() {
    if (this.memberSelect != null) {
      this.cS.loadPriceModel(this.memberSelect);
      this.cS.getCultivarList();
      this.cS.loadOverview(this.memberSelect);
    }
    this.lS.memberships = JSON.parse(localStorage.getItem('memberships'));
  }

  onMemberSelected(membership, membername, season) {
    this.memberSelect = this.lS.selectMembership(membership, season);
    this.hS.refreshMenu();
    this.cacheForMember();
  }

  onSeasonSelected() {
    this.cacheForMember();
  }

  isAuthenticated(option = null) {
    if (option==null) {
      return this.lS.isAuthenticated();
    }
    if (this.pS.portalMod()[option] || this.pS.portalMod()['mod-all']) {
      return this.lS.isAuthenticated();
    } return false;
  }

  setSeasons() {
    this.lS.seasons = [];
    for (var i = +this.d.getFullYear(); i >= 2019; i--) {
      this.lS.seasons.push({"season": String(i)});
    }
  }

}
